
export interface OrderListApiResponse {

  /** 当前页码 */
  pageNo: number;

  /** 每页大小 */
  pageSize: number;

  /** 总记录数 */
  totalCount: number;

  /** 总页数 */
  totalPages: number;

  /** 结果列表 */
  result: OrderApiItem[];
}

export interface OrderApiItem {

  /** 订单唯一标识符 */
  id: string;

  /** 订单创建时间戳 */
  createdTime: number;
  payType: PayTypeEnum

  /** 业务订单ID */
  bizOrderId: string;

  /** 操作员工姓名 */
  staffName: string;

  /** 操作员工邮箱 */
  staffEmail: string;

  /** 业务订单状态 订单状态 10-已提单 20-已支付 30-商家已确认 40-订单已完成 50-订单已取消 */
  bizOrderStatus: number;

  /** 订单金额 */
  orderAmount: AmountDetails;

  /** 实际支付金额 */
  realPayAmount: AmountDetails;

  // 订单备注
  remark: string;

  /** 成本中心名称 */
  costCenterName?: string;

  /** 费用代码 */
  expenseCode?: string;

  /** 费用备注 */
  expenseRemark?: string;

  /** 取货方式 */
  userGetMode?: string;
}

export interface AmountDetails {

  /** 订单金额 */
  amount: number;

  /** 货币类型 */
  currency: string;

  /** 显示文本 */
  displayText: string;

  /** 显示的订单金额 */
  displayAmount: string;
}

export interface OrderListApiRequest { 
  /** 页码  默认1  */
  pageNo: number; 
  /** 支付方式 */
 
  payType?: PayTypeEnum; 
  /** 每页条数  默认20 最大100 */
  pageSize: number; 
  /** 员工姓名 */
  staffName?: string; 
  /** 订单号-精确查询 */
  bizOrderId?: string; 
  /** 员工邮箱-精确查询 */
  staffEmail?: string; 
  /** 下单结束时间戳 */
  createTimeEnd?: number; 
  /** 订单状态 10-已提单 20-已支付 30-商家已确认 40-订单已完成 50-订单已取消 */
  bizOrderStatus?: BizOrderStatusEnum;
  /** 下单开始时间戳 */
  createTimeStart?: number;
  /** 成本中心名称 */
  costCenterName?: string;
  /** 费用代码 */
  expenseCode?: string;
  /** 备注 */
  remark?: string;
}


/** 支付方式枚举 */
export enum PayTypeEnum {
  /** 企业支付 */
  CorporatePay = 'corporatePay',
  /** 个人支付 */
  PersonalPay = 'personalPay',
  /** 组合支付 */
  CombinedPay = 'combinedPay',
}

/** 订单状态枚举 */
export enum BizOrderStatusEnum {
  /** 已提单 */
  Submitted = 10,
  /** 已支付 */
  Paid = 20,
  /** 商家已确认 */
  Confirmed = 30,
  /** 订单已完成 */
  Completed = 40,
  /** 订单已取消 */
  Cancelled = 50,
}





export interface OrderDetailApiData {
  /** 订单基本信息 */
  orderBaseInfo: ApiOrderBaseInfo;

  /** 员工信息 */
  staffInfo: ApiStaffInfo;

  /** 原始订单信息 */
  origOrderInfo: ApiOrigOrderInfo;

  /** 费控信息（费用代码、费用备注） */
  controlInfo?: ApiControlInfo;
}

export interface ApiStaffInfo {
  /** 员工姓名 */
  staffName: string;

  /** 员工的电子邮箱 */
  staffEmail: string;

  /** 员工类别 */
  staffCategory: string;

  /** 员工的工号 */
  staffEmployeeNum: string;

  /** 员工所属部门路径 */
  departmentNamePath: string;

  /** 成本中心ID */
  costCenterId?: number;

  /** 成本中心名称 */
  costCenterName?: string;
}

export interface ApiControlInfo {
  /** 费用代码 */
  expenseCode?: string;

  /** 费用备注 */
  expenseRemark?: string;
}

export interface ApiOrderBaseInfo {
  /** 业务订单ID */
  bizOrderId: string;

  /** 订单创建时间戳 */
  createdTime: number;

  /** 订单状态 10-已提单 20-已支付 30-商家已确认 40-订单已完成 50-订单已取消 */
  orderStatus: number;

  /** 支付方式 corporatePay-企业支付 personalPay-个人支付 combinedPay-组合支付 */
  payType: string;

  /** 订单金额 */
  orderAmount: AmountDetails;

  /** 实际支付金额 */
  realPayAmount?: AmountDetails;

  /** 企业支付金额 */
  corporatePayAmount?: AmountDetails;

  /** 个人支付金额 */
  personalPayAmount?: AmountDetails;

  /** 企业退款金额 */
  corporateRefundAmount?: AmountDetails;

  /** 个人退款金额 */
  personalRefundAmount?: AmountDetails;
  /** 下单 Region */ 
  region: string;
  /** 退款类型，未退款为null，全部退款：fullRefund，部分退款：partialRefund */
  refundType: string;
  /** 成本中心名称 */
  costCenterName?: string;
  /** 费用代码 */
  expenseCode?: string;
  /** 费用备注 */
  expenseRemark?: string;
}

export interface ApiAmountDetails {
  /** 订单金额 */
  amount: number;

  /** 货币类型 */
  currency: string;

  /** 显示的订单金额文本 */
  displayText: string;

  /** 可读的订单金额展示 */
  displayAmount: string;
}

export interface ApiOrigOrderInfo {
  /** 原始业务订单ID */
  bizOrderId: string;

  /** 商店名称 */
  shopName: string;

  /** 商品名称列表 */
  itemNames: string;

  /** 用户获取方式 delivery：外卖  pickup：自取  可能为空字符串 */
  userGetMode: 'delivery' | 'pickup';

  /** 折扣金额 */
  discountAmount: AmountDetails;

  /** 实际运费 */
  shippingFee: AmountDetails;

  /** 备注信息 */
  remark: string;

  /** 商家地址 */
  shopAddress: string;

  /** 收货地址 */
  recipientAddress: string;

  /** 菜品与金额详情 */
  foodAmountDetail: FoodAmountDetail;
}

export interface FoodAmountDetail {
  /** 商品详情列表 */
  products: Product[];

  /** 商品总价 */
  productTotalAmount: AmountDetails;

  /** 配送费 */
  shippingFee: AmountDetails;

  /** 平台费（真实） */
  platformFee: AmountDetails;

  /** 贴士（小费） */
  tip: AmountDetails;

  /** 总价 */
  totalAmount: AmountDetails;

  /** 优惠信息列表 */
  promotions: Promotion[];

  /** 总优惠金额 */
  totalDiscountAmount: AmountDetails;

  /** 实际支付金额 */
  actualPaymentAmount: AmountDetails;

  /** 退款总金额 */
  totalRefundAmount: AmountDetails;

  /** 最低价补差 */
  diffPrice: AmountDetails;
}

export interface Product {
  /** 商品名称 */
  name: string;

  /** 商品数量 */
  count: number;

  /** 商品价格 */
  price: AmountDetails;

  // 退款信息
  refundAmount: AmountDetails;
}

export interface Promotion {
  /** 优惠规则描述 */
  promotionRuleDesc: string;

  /** 优惠金额 */
  reduceFee: AmountDetails;
}

/**
 * https://f1-better.sankuai.com/#/home?projectId=930&api_project_id=92715&api_id=74444
 * 订单导出接口
*/
export interface IOrderQueryParam {
  payType?: string;
  staffName?: string;
  staffEmail?: string;
  createTimeStart?: number;
  createTimeEnd?: number;
  orderStatus?: string;
  bizOrderId?: string;
  userGetMode?: string;
  bizOrderStatus?: string;
  /** 成本中心名称 */
  costCenterName?: string;
  /** 费用代码 */
  expenseCode?: string;
}
export interface IOrderDownloadExcelParams {
  exportByCondition?: boolean;
  locale: string;
  orderQueryParam?: IOrderQueryParam;
  orderIds?: Array<React.Key>;
}
export interface OrderExportApiResponse {
  status: string;
  message: string;
  data: string;
}

export interface ReceiptDownloadApiResponseData {
  /** 下载链接 */
  url: string;
}

export interface ReceiptDownloadApiResponse {
  url: string;
}